export default "__VITE_ASSET__Cq$HxcX3__"